import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="menu"
export default class extends Controller {
  connect() {
  }

  changeStartingWeek(event){
    const newPath = `${event.params.activitiesPath}?starting_week=${event.target.value}`
    window.location.href = newPath;
  }

  changeStartingPeriod(event){
    const fieldName = event.target.name;
    const newPath = `${event.params.activitiesPath}?${fieldName}=${event.target.value}`
    window.location.href = newPath;
  }
}
